module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAJCAYAAABaMo5wAAAAtUlEQVQ4T83TMWpCURAF0PO1EKyCINi5AlegdcDezlIbW8E2RWqVQEgnuhHdgI24A12CIFiJMvKF4ALed6oHr5jDzJ1M2qphih5W+MLpPyFL61FGGwtUMMAGt6cjNSj6BmSIb+zy96FIUPRu4AddzDHDOT6KmNCzbwtLfGCEdawuQHVUUSogT32Msc1XdwzQHz55BC5lRZBjEDGQS359vwGKxMcuU4Nerz2CPQlQB803AF2xvwNuTRqHHRfu3AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiantou.png
// module id = JSah
// module chunks = 2